import React from "react";

const Disclaimer = ({ darkTheme }) => {
  return (
    <div
      id="disclaimer"
      className="modal fade"
      role="dialog"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div
          className={
            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
          }
        >
          <div className="modal-header">
            <h5 className={"modal-title " + (darkTheme ? "text-white" : "")}>
              Copyright &amp; Disclaimer
            </h5>
            <button
              type="button"
              className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body p-4">
            <p>
            Die Inhalte der Webseiten, die von Johannes Skalla verfasst wurden und instandgehalten werden mit allen darin enthaltenen Information,
            egal ob als Text, Graphiken, Bilder, Design und Quellcode oder andere Formen, sind und bleiben das Eigentum von Johannes Skalla
            und sind durch Urheberrechte, Copyrights, Marken, Muster und Patentrechte, Nutzungsrechte, Patente oder andere Eigentumsrechte geschützt.<br />
            <br />
            Der Inhalt dieser Seiten darf ohne die vorherige schriftliche Erlaubnis durch Johannes Skalla in keiner Art und Weise verändert, vervielfältigt, veröffentlicht, oder übertragen werden.
            Zur persönlichen, nicht kommerziellen Nutzung, darf der dargestellte Inhalt heruntergeladen, gedruckt und verteilt werden, wenn der Inhalt unverändert bleibt.
            Alle Kopien vom Inhalt oder Auszüge aus diesen Seiten müssen alle Eigentumsnachweise vom Eigentümer des Copyrights, Urheber-, Marken, Muster und Patentrechte und sonstige Rechte enthalten.<br />
            <br />
            Die Erstellung und Verbreitung von veränderten, erweiterten, gekürzten oder in Fremdsprachen übersetzten Inhalten ist nur nach schriftlicher Genehmigung des Eigentümers erlaubt.<br />
            <br />
            Sie sind berechtigt, Hyperlinks zu diesen Seiten zu knüpfen, aber gleichzeitig verpflichtet, die Unterschiede zwischen Ihren Informationen und denen von Johannes Skalla deutlich erkennbar zu machen.
            Die Seiten von Johannes Skalla dürfen nicht als Teil der eigenen Seite erscheinen.<br />
            <br />
            Nach den allgemeinen Gesetzen ist der Betreiber einer Seite für dessen Inhalt verantwortlich.
            Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
            Für die Richtigkeit, Vollständigkeit und Aktualität der auf dieser Website dargelegten einzelnen Seiten wird jedoch keine Haftung übernommen.<br />
            <br />
            Die Website kann unter Anderem Links zu Websites von Dritten auf deren Inhalt kein Einfluss genommen werden kann und daher für deren Inhalt auch keine Gewähr übernommen wird.
            Eine permanente Kontrolle der verlinkten Websites ist jedoch wegen dem dauernden Wandel der Websites und der umfangreichen Linksammlung ohne konkreten Anhaltspunkt nicht zumutbar.
            Bei bekannt werden von Rechtsverletzungen werden diese Links umgehend von uns entfernt.<br />
            </p>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Kontakt-Formular
            </h5>
            Für die Kontaktaufnahme stellt diese Seite ein Formular zur Verfügung. Nachrichten die darüber versendet werden laufen über den Dienst&nbsp;
            <a href="https://www.emailjs.com/">EmailJS.com</a> und <a href="https://mail.google.com/mail/">Google Mail</a>. Diese Dienste können zumindest folgende Daten einsehen:
            <ul className="lh-lg">
              <li>Eingegebene Formulardaten wie Name, E-Mail-Adresse sowie Nachricht</li>
              <li>Verwendetes Betriebssystem, Browser und dessen Versionen</li>
            </ul>
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              Google Schriftarten
            </h5>
            Diese Website verwendet die Google Schriftart <a href="https://fonts.google.com/specimen/Poppins">Poppins</a>,
            diese wird jedoch lokal auf dem Server bereitgestellt und enthält keine Referenzen zu Google Servern.<br />
            <br />
            Die Schriftart darf unter Einhaltung der <a href="https://scripts.sil.org/OFL">SIL OFL 1.1 License</a> verwendet werden.
            <h5 className={"text-4 mt-4 " + (darkTheme ? "text-white" : "")}>
              FontAwesome Schriftarten und Symbole
            </h5>
            Diese Website verwendet freie Schriftarten und Symbole von <a href="https://fontawesome.com/">FontAwesome</a>,
            diese werden jedoch ebenfalls lokal auf dem Server bereitgestellt und enthalten keine Referenzen zu Servern von FontAwesome.com<br />
            <br />
            Die Schriftarten und Symbole von FontAwesome unterliegen <a href="https://fontawesome.com/license/free">den folgenden Lizenzen</a>:<br />
            <ul className="lh-lg">
              <li>Icons - <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0 License</a></li>
              <li>Fonts - <a href="https://scripts.sil.org/OFL">SIL OFL 1.1 License</a></li>
              <li>Code - <a href="https://opensource.org/licenses/MIT">MIT License</a></li>
            </ul>
            <p>
            © Johannes Skalla. All rights reserved.
            </p>
            {/*
            <ul className="lh-lg">
              <li>
                Lisque persius interesset his et, in quot quidam persequeris
                vim, ad mea essent possim iriure.
              </li>
              <li>
                Quidam lisque persius interesset his et, Lisque persius
                interesset his et, in quot quidam persequeris vim, ad mea essent
                possim iriure.
              </li>
              <li>
                In quot quidam persequeris vim, ad mea essent possim iriure.
                Quidam lisque persius interesset his et.
              </li>
              <li>
                Quidam lisque persius interesset his et, Lisque persius
                interesset his et.
              </li>
              <li>
                Interesset his et, Lisque persius interesset his et, in quot
                quidam persequeris vim, ad mea essent possim iriure.
              </li>
              <li>
                Persius interesset his et, Lisque persius interesset his et, in
                quot quidam persequeris vim, ad mea essent possim iriure.
              </li>
              <li>
                Quot quidam persequeris vim Quidam lisque persius interesset his
                et, Lisque persius interesset his et, in quot quidam persequeris
                vim, ad mea essent possim iriure.
              </li>
            </ul>
            */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
